export const data = {
  ticketId: 10023,
  currentStatus: {
    status: "Under Investigation",
    date: "20-12-18:18:3:00",
  },

  ticketDetails: {
    dateCreated: "20-12-18:3:00",
    summary: "Lorem ipsum dolor sit amet consectetur adipisicing elit.",
    description: "Lorem ipsum dolor sit amet consectetur adipisicing elit.",
    customerName: "Johnson Drake",
    phone: "0932342345",
    customerEmail: "johnson_drake@gmail.com",
    category: "Repair",
    subCategory: "Maintenance",
  },
  statusHistory: [
    {
      status: "open",
      time: "20-12-18:18:3:00",
      comment:
        "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Iste soluta eius fugiat!",
    },
    {
      status: "open",
      time: "20-12-18:18:3:00",
      comment:
        "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Iste soluta eius fugiat!",
    },
  ],
};

export type Data = typeof data;

export const conversation = [
  {
    name: "James OluwaSeun",
    time: "14:04:15, Thursday Jul 16, 2021",
    message:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Ratione illum error fuga quibusdam ducimus dicta at accusantium dolorum.",
    attachments: {
      file: "Document 1",
    },
    isSender: false,
  },
  {
    name: "James OluwaSeun",
    time: "14:04:15, Thursday Jul 16, 2021",
    message:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Ratione illum error fuga quibusdam ducimus dicta at accusantium dolorum.",
    attachments: {
      file: "Document 1",
    },
    isSender: false,
  },
  {
    name: "James OluwaSeun",
    time: "14:04:15, Thursday Jul 16, 2021",
    message:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Ratione illum error fuga quibusdam ducimus dicta at accusantium dolorum.",
    attachments: {
      file: "Document 1",
    },
    isSender: false,
  },
  {
    name: "James OluwaSeun",
    time: "14:04:15, Thursday Jul 16, 2021",
    message:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Ratione illum error fuga quibusdam ducimus dicta at accusantium dolorum.",
    attachments: {
      file: "Document 1",
    },
    isSender: false,
  },
  {
    name: "James OluwaSeun",
    time: "14:04:15, Thursday Jul 16, 2021",
    message:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Ratione illum error fuga quibusdam ducimus dicta at accusantium dolorum.",
    attachments: {
      file: "Document 1",
    },
    isSender: false,
  },
];

export type Conversation = typeof conversation;
